<template>
  <div class="focused-panel">
    <div class="d-flex access-track-toolbar">
      <!--<div class="p-2">{{wellFeature ? wellFeature.get('ident') : 'No well selected'}}</div>-->
      <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create access track" :pressed.sync="addEnabled" variant="primary">
        <icon scale=".6" name="plus"/>
      </b-btn>

      <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select access track" :pressed.sync="selectEnabled" variant="primary">
        <icon scale=".6" name="hand-pointer"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Multi Select" :pressed.sync="multiEdit" variant="primary">
        <icon scale=".6" name="dice-two" />
      </b-btn>

      <b-btn class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges" @click="undo" variant="primary">
        <icon scale=".6" name="undo"/>
      </b-btn>
      <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
        Undo
      </b-tooltip>


      <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit access track geometry" :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled"
             variant="primary">
        <icon scale=".6" name="arrows-alt"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" variant="primary" :disabled="!mergeEnabled" v-b-tooltip.hover.auto title="Merge 2 tracks" @click="mergeLines">
        <icon scale=".6" name="compress" />
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" variant="primary" @click="reverseSelected" :disabled="!wellFeatureSelected" v-b-tooltip.hover.auto title="Reverse">
        <icon scale=".6" name="exchange-alt" />
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" variant="primary" :disabled="!wellLayerLoaded" :pressed.sync="ratEnabled" v-b-tooltip.hover.auto title="Draw RAT">
        <icon scale=".6" name="bezier-curve" />
      </b-btn>

      <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit access track attributes" :disabled="!wellFeatureSelected" :pressed.sync="editEnabled"
             variant="primary">
        <icon scale=".6" name="pencil-alt"/>
      </b-btn>

      <b-btn class="dtron-toolbar-button tool1" @click="deleteFetaures" v-b-tooltip.hover.auto title="Delete access tracks" :disabled="!wellFeatureSelected"
             variant="primary">
        <icon scale=".6" name="times"/>
      </b-btn>

      <b-btn class="dtron-toolbar-button tool1" :pressed.sync="ldEnabled" v-b-tooltip.hover.auto title="Load dependant layers"
             variant="primary">
        <icon scale=".6" name="link"/>
      </b-btn>

    </div>

    <b-modal v-model="showForm" no-close-on-backdrop no-close-on-esc>
      <div slot="modal-header">
        <label>{{formTitle}}</label>
        <div v-if='editablePhase'>
          <div v-if="!featureLock" class='designatron-lock' v-b-tooltip.hover.auto title="Lock Feature" @mouseover="hoverLock = true" @mouseleave="hoverLock = false">
            <span v-if='hoverLock' @click='setLockState(true)'><icon scale=".8" name="lock"/></span>
            <span v-if="!hoverLock"><icon scale=".8" name="unlock"/></span>
          </div>

          <div v-if="featureLock" class='designatron-lock' v-b-tooltip.hover.auto title="Unlock Feature" @mouseover="hoverLock = true" @mouseleave="hoverLock = false">
            <span v-if='hoverLock' @click='setLockState(false)'><icon scale=".8" name="unlock"/></span>
            <span v-if="!hoverLock"><icon scale=".8" name="lock"/></span>
          </div>
        </div>
      </div>
      <div class="p-2">
        <div id='feature-locked-warning' v-if="!editablePhase">
          <b-alert class='user-reminder' variant="warning" show>This feature is locked. It cannot be edited in this Area of responsibility</b-alert>
        </div>
        <div id='feature-locked-warning-phase' v-if="editablePhase && featureLock">
          <b-alert class='user-reminder' variant="warning" show>This feature is locked. Click the unlock button in the upper right to edit feature</b-alert>
        </div>
        <b-form>
          <b-form-group label="Asset Tag:" label-for="track-asset-tag">
            <b-form-input :disabled="featureLock" id="track-asset-tag" v-model="wellAttrs['asset_tag']" placeholder="Enter Asset Tag"></b-form-input>
          </b-form-group>
          <b-form-group label="Type:" label-for="access-track-type">
            <b-form-select id="access-track-type"
                          :disabled="featureLock"
                          v-model="track_type"
                          :options="tracks_types"
                          placeholder="Select access track type"
            ></b-form-select>
          </b-form-group>
          <b-form-group label="Comment:" label-for="accessComment">
            <b-textarea id="accessComment" :disabled="featureLock" v-model="wellAttrs['comments']" rows="3"></b-textarea>
          </b-form-group>

        </b-form>
      </div>
      <div slot="modal-footer" class="designatron-modal-footer">
        <b-row>
          <!-- <b-col>
            <div id="update-survey-container">
              <b-btn size="sm" @click="surveyUpdate">
                Update from survey
              </b-btn>
            </div>
          </b-col> -->
          <b-col>
            <div role="group" class="btn-group">
              <b-btn size="sm" class="float-right" variant="primary" @click="close">
                Close
              </b-btn>
              <b-btn size="sm" :disabled="featureLock" class="float-right" variant="success" @click="onOK">
                Save
              </b-btn>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>


  </div>
</template>

<script>


  import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'
  import Draw from 'ol/interaction/Draw'
  import Snap from 'ol/interaction/Snap'
  import bezierCurve from '@turf/bezier-spline'
  import GeoJSON from 'ol/format/GeoJSON'
  import { LineString } from 'ol/geom'

  export default {
    name: 'access-track-editor',
    components: {},
    mixins: [FeatureEditorMixin],
    data () {
      return {
        multiEdit: false,
        mergeEnabled: false,
        ratEnabled: false,
        geomType: 'LineString',
        wellLayerName: 'v4:access_track_centreline',
        wellAttrs: {
          ident: '',
          comments: '',
          library_id: null,
          asset_tag: ''
        },
        schema: 'access_track_centreline',
        track_type: 0,
        tracks_types: [],
        ratPoints: [],
        identState: null,
        initialIdent: null,
        hoverLock: false,
        lockable: true
      }
    },
    methods: {
      initRat () {

        if (!this.wellLayer) {

        }

        if (!this.wellLayer) {
          this.checkResources()
          this.$notify({
            title: 'ERROR',
            text: 'Please, make sure access track centreline layer loaded. May be try in new seconds',
            type: 'error'
          })
          return;
        }

        this.draw = new Draw({
          source: this.servicingLayer.getSource(),
          type: 'Point',
        });

        this.$mapService.map.addInteraction(this.draw);

        let me = this
        this.draw.on('drawend', function (e) {
          me.ratPoints.push(e.feature.clone())
        })

        this.snap = new Snap({
          source: this.wellLayer.getSource(),
        });
        this.$mapService.map.addInteraction(this.snap);
      },
      deinitRat () {
        this.$mapService.map.removeInteraction(this.draw);
        this.$mapService.map.removeInteraction(this.snap);
      },
      drawRatCurve (pts) {
        if (!this.geoJson) {
          this.geoJson = new GeoJSON({
            geometryName: 'geo'
          })
        }

        let f = new LineString(pts)
        let gsObj = this.geoJson.writeGeometryObject(f)

        let curve = bezierCurve(gsObj)
        let curveFeature = this.geoJson.readFeatureFromObject(curve)

        curveFeature.set('workpack_id', this.currentProject.workpack.id)
        curveFeature.set('last_modified_user', this.user.username)
        curveFeature.set('last_modified_date', new Date().toISOString())

        this._addFeature(curveFeature)
        this.servicingLayer.getSource().addFeature(curveFeature)

      },
      reverseSelected() {
        let lines = this.selectInteraction.getFeatures().getArray()
        lines.forEach(line => {
          line.getGeometry().setCoordinates(line.getGeometry().getCoordinates().reverse())
        })
        this._edit(lines)
        this.selectInteraction.getFeatures().clear()
      },
      loadTypeLibrary() {
        this.$http.get('/api/layers/access-track-type').then(res => {
          let fil = res.body.filter(f => f.subject)
          this.tracks_types = fil.map(m => {
            return {
              text: m.subject,
              value: m.id
            }
          })
          this.tracks_types = this.tracks_types.concat({
            text: 'None',
            value: 0
          })
          if (this.wellFeature.get('library_id')) {
            this.track_type = JSON.parse(this.wellFeature.get('library_id'))
          } else {
            this.track_type = 0
          }
        }, res => {
          console.log('Error Thrown')
          console.log(res)
        })
      },
      close(evt) {
        this.wellFeature = null
        this.showForm = false
        this.onCancel()
      },
      surveyUpdate() {
        this.updateFeatureFromSurvey()
        this.close()
      }
    },
    watch: {
      ratPoints (val) {
        if (val.length === 3) {

          let points = this.ratPoints.map(f => f.getGeometry().getCoordinates())
          this.drawRatCurve(points)
          this.servicingLayer.getSource().clear();

          this.ratPoints.splice(0, this.ratPoints.length)
        }
      },
      ratEnabled (val) {
        if (val) {
          this.initRat()
        } else {
          this.deinitRat()
        }
      },
      countSelectedFeatures(val) {
        this.mergeEnabled = val === 2
      },
      showForm(val) {
        if (this.tracks_types.length == 0) {
          this.loadTypeLibrary()
        } else {
          if (this.wellFeature.get('library_id')) {
            this.track_type = JSON.parse(this.wellFeature.get('library_id'))
          } else {
            this.track_type = 0
          }
        }
      },
      wellAttrs: {
        handler(val) {
          if (!this.initialIdent) {
            this.initialIdent = val.ident
          }
          else if (this.initialIdent !== val.ident) {
            let me = this
            this.validateIdent(val.ident)
          } else {
            this.identState = null
          }
        },
        deep: true
      },
      track_type(val) {
        if (val) {
          this.wellAttrs['library_id'] = val
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/AccessTrackEditor.vue